var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ae-basic-from" },
    [
      _c(
        "div",
        { staticStyle: { width: "fit-content" } },
        [
          _c(
            "el-form",
            {
              ref: "basicForm",
              staticStyle: { display: "flex" },
              attrs: { "label-position": "left", "label-width": "90px" }
            },
            [
              _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "form-card-wrapper",
                    staticStyle: { "flex-direction": "column" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "flex-direction": "row"
                        }
                      },
                      [
                        _c("el-card", { staticClass: "form-card" }, [
                          _c(
                            "fieldset",
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: _vm.$t("SeaExport.JobNo") } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      no: "1",
                                      disabled: _vm.viewStatus
                                    },
                                    model: {
                                      value: _vm.job.jobNo,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "jobNo", $$v)
                                      },
                                      expression: "job.jobNo"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.OperateType")
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      no: "2",
                                      filterable: "",
                                      disabled: _vm.viewStatus,
                                      "select-type":
                                        _vm.selectTypeNames
                                          .local_cache_AirExportConstants$BUSINESS_MODELS,
                                      "callback-method-type": "value",
                                      "default-value": _vm.job.operateType,
                                      "callback-params": { key: "operateType" }
                                    },
                                    on: {
                                      parentCallBack: _vm.setJobSelectValue
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SeaExport.ConsignationCompany"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "center"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-tooltip",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.creditTip.showWarningImageB,
                                              expression:
                                                "creditTip.showWarningImageB"
                                            }
                                          ],
                                          attrs: {
                                            content:
                                              _vm.creditTip.warningImageBTip,
                                            placement: "right-end"
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-warning",
                                            staticStyle: { color: "red" }
                                          })
                                        ]
                                      ),
                                      _c("cargo-advance-select", {
                                        attrs: {
                                          no: "3",
                                          disabled: _vm.viewStatus,
                                          filterable: "",
                                          "select-type":
                                            _vm.selectTypeNames
                                              .basic_data_Company,
                                          "method-params": { customer: true },
                                          "callback-method-type": "value",
                                          "default-value":
                                            _vm.job.customerId || "",
                                          "callback-params": {
                                            key: "customerId"
                                          }
                                        },
                                        on: {
                                          parentCallBack: _vm.setJobSelectValue
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.CustomerProperty")
                                  }
                                },
                                [
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content: _vm.customerTip,
                                        placement: "bottom"
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.customerLevel.customerName,
                                              expression:
                                                "customerLevel.customerName"
                                            }
                                          ],
                                          staticStyle: { color: "#FD9A14" }
                                        },
                                        [
                                          _vm._v(
                                            "LV" +
                                              _vm._s(_vm.customerLevel.level)
                                          )
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.customerLevel.customerName,
                                              expression:
                                                "customerLevel.customerName"
                                            }
                                          ],
                                          staticStyle: { color: "#D3A73B" }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.customerLevel.customerName
                                              )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.contractStatusLabel,
                                              expression: "contractStatusLabel"
                                            }
                                          ],
                                          staticStyle: { color: "red" }
                                        },
                                        [
                                          _vm._v(
                                            " (" +
                                              _vm._s(_vm.contractStatusLabel) +
                                              ")"
                                          )
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.advancePaymentLabel,
                                              expression: "advancePaymentLabel"
                                            }
                                          ],
                                          staticStyle: { color: "brown" }
                                        },
                                        [
                                          _vm._v(
                                            " (" +
                                              _vm._s(_vm.advancePaymentLabel) +
                                              ")"
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.LoadingPort")
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "space-between"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: {
                                          width: "60px",
                                          "margin-right": "5px"
                                        },
                                        attrs: {
                                          no: "4",
                                          disabled: _vm.viewStatus
                                        },
                                        model: {
                                          value: _vm.job.loadingPortCode,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.job,
                                              "loadingPortCode",
                                              $$v
                                            )
                                          },
                                          expression: "job.loadingPortCode"
                                        }
                                      }),
                                      _c("cargo-advance-select", {
                                        staticStyle: { flex: "1" },
                                        attrs: {
                                          no: "5",
                                          filterable: "",
                                          disabled: _vm.viewStatus,
                                          "select-type":
                                            _vm.selectTypeNames
                                              .basic_data_Airport,
                                          "callback-method-type": "value",
                                          "default-value":
                                            _vm.job.loadingPortCode,
                                          "callback-params": {
                                            key: "loadingPortCode"
                                          }
                                        },
                                        on: {
                                          parentCallBack: _vm.setJobSelectValue
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.PortOfDestination")
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "space-between"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: {
                                          width: "60px",
                                          "margin-right": "5px"
                                        },
                                        attrs: {
                                          no: "6",
                                          disabled: _vm.viewStatus
                                        },
                                        model: {
                                          value: _vm.job.destinationPortCode,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.job,
                                              "destinationPortCode",
                                              $$v
                                            )
                                          },
                                          expression: "job.destinationPortCode"
                                        }
                                      }),
                                      _c("cargo-advance-select", {
                                        staticStyle: { flex: "1" },
                                        attrs: {
                                          no: "7",
                                          filterable: "",
                                          disabled: _vm.viewStatus,
                                          "select-type":
                                            _vm.selectTypeNames
                                              .basic_data_Airport,
                                          "callback-method-type": "value",
                                          "default-value":
                                            _vm.job.destinationPortCode,
                                          "callback-params": {
                                            key: "destinationPortCode"
                                          }
                                        },
                                        on: {
                                          parentCallBack: _vm.setJobSelectValue
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: _vm.$t("SeaExport.Airline") }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      no: "8",
                                      disabled: _vm.viewStatus
                                    },
                                    model: {
                                      value: _vm.job.vesselLine,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "vesselLine", $$v)
                                      },
                                      expression: "job.vesselLine"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c("el-form-item", { attrs: { label: "" } }, [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "justify-content": "space-between"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-checkbox",
                                      {
                                        attrs: {
                                          no: "9",
                                          disabled: _vm.viewStatus
                                        },
                                        model: {
                                          value: _vm.job.transfering,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.job,
                                              "transfering",
                                              $$v
                                            )
                                          },
                                          expression: "job.transfering"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("SeaExport.Transit"))
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "10",
                                          disabled: _vm.viewStatus,
                                          type: "primary"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("SeaExport.EnterTransitInfo")
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("Payment.solicitationType")
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "space-between"
                                      }
                                    },
                                    [
                                      _c("cargo-advance-select", {
                                        staticStyle: { width: "98px" },
                                        attrs: {
                                          no: "11",
                                          filterable: "",
                                          disabled: _vm.viewStatus,
                                          "select-type":
                                            _vm.selectTypeNames
                                              .local_cache_CargoSource,
                                          "callback-method-type": "value",
                                          "default-value": _vm.job.cargoSource,
                                          "callback-params": {
                                            key: "cargoSource"
                                          }
                                        },
                                        on: {
                                          parentCallBack: _vm.setJobSelectValue
                                        }
                                      }),
                                      _c("cargo-advance-select", {
                                        staticStyle: { width: "98px" },
                                        attrs: {
                                          no: "12",
                                          filterable: "",
                                          disabled: _vm.viewStatus,
                                          "select-type":
                                            _vm.selectTypeNames
                                              .basic_data_CutomJobType,
                                          "method-params": {
                                            type: _vm.job.lob,
                                            active: true
                                          },
                                          "callback-method-type": "value",
                                          "default-value":
                                            _vm.job.customJobType,
                                          "callback-params": {
                                            key: "customJobType"
                                          }
                                        },
                                        on: {
                                          parentCallBack: _vm.setJobSelectValue
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SeaExport.PortOfLoadingAgent"
                                    )
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      no: "13",
                                      disabled: _vm.viewStatus,
                                      filterable: "",
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_Company,
                                      "method-params": { localAgent: true },
                                      "callback-method-type": "value",
                                      "default-value": _vm.job.localAgent || "",
                                      "callback-params": { key: "localAgent" }
                                    },
                                    on: {
                                      parentCallBack: _vm.setJobSelectValue
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.DestinationAgent")
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "center"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-tooltip",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.creditTip.showWarningImageC,
                                              expression:
                                                "creditTip.showWarningImageC"
                                            }
                                          ],
                                          attrs: {
                                            content:
                                              _vm.creditTip.warningImageCTip,
                                            placement: "right-end"
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-warning",
                                            staticStyle: { color: "red" }
                                          })
                                        ]
                                      ),
                                      _c("cargo-advance-select", {
                                        attrs: {
                                          no: "14",
                                          disabled: _vm.viewStatus,
                                          filterable: "",
                                          "select-type":
                                            _vm.selectTypeNames
                                              .basic_data_Company,
                                          "method-params": {
                                            overseaAgent: true
                                          },
                                          "callback-method-type": "value",
                                          "default-value":
                                            _vm.job.destinationAgent || "",
                                          "tag-name": "englishName",
                                          "callback-params": {
                                            key: "destinationAgent"
                                          }
                                        },
                                        on: {
                                          parentCallBack: _vm.setJobSelectValue
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _vm.job.cargoSource === "NC"
                                ? _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "SeaExport.NominatedAgent"
                                        )
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-tooltip",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.creditTip
                                                      .showWarningImageA,
                                                  expression:
                                                    "creditTip.showWarningImageA"
                                                }
                                              ],
                                              attrs: {
                                                content:
                                                  _vm.creditTip
                                                    .warningImageATip,
                                                placement: "right-end"
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-warning",
                                                staticStyle: { color: "red" }
                                              })
                                            ]
                                          ),
                                          _c("cargo-advance-select", {
                                            attrs: {
                                              no: "15",
                                              disabled: _vm.viewStatus,
                                              filterable: "",
                                              "select-type":
                                                _vm.selectTypeNames
                                                  .basic_data_Company,
                                              "method-params": {
                                                overseaAgent: true
                                              },
                                              "callback-method-type": "value",
                                              "default-value":
                                                _vm.job.designationAgent || "",
                                              "tag-name": "englishName",
                                              "callback-params": {
                                                key: "designationAgent"
                                              }
                                            },
                                            on: {
                                              parentCallBack:
                                                _vm.setJobSelectValue
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.BookingAgent")
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      no: "16",
                                      disabled: _vm.viewStatus,
                                      filterable: "",
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_Company,
                                      "method-params": { bookingAgent: true },
                                      "callback-method-type": "value",
                                      "default-value":
                                        _vm.job.bookingAgent || "",
                                      "callback-params": { key: "bookingAgent" }
                                    },
                                    on: {
                                      parentCallBack: _vm.setJobSelectValue
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.DocCutOffDate")
                                  }
                                },
                                [
                                  _c("el-date-picker", {
                                    attrs: {
                                      no: "17",
                                      disabled: _vm.viewStatus,
                                      type: "date",
                                      clearable: "",
                                      format: "yyyy-MM-dd HH:mm",
                                      "value-format": "yyyy-MM-dd HH:mm"
                                    },
                                    model: {
                                      value: _vm.job.fileCutoff,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "fileCutoff", $$v)
                                      },
                                      expression: "job.fileCutoff"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.MasterBillNo")
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "center"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-checkbox",
                                        {
                                          staticStyle: {
                                            "margin-right": "5px"
                                          },
                                          attrs: { no: "18" },
                                          model: {
                                            value: _vm.job.express,
                                            callback: function($$v) {
                                              _vm.$set(_vm.job, "express", $$v)
                                            },
                                            expression: "job.express"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("SeaExport.ExpressInfo")
                                            )
                                          )
                                        ]
                                      ),
                                      !_vm.job.express
                                        ? _c("el-input", {
                                            staticStyle: { width: "80px" },
                                            attrs: {
                                              no: "19",
                                              value: _vm.job.mbl.substring(
                                                0,
                                                3
                                              ),
                                              disabled: _vm.viewStatus
                                            }
                                          })
                                        : _vm._e(),
                                      !_vm.job.express
                                        ? _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "padding-right": "1.5px",
                                                "padding-left": "1.5px"
                                              }
                                            },
                                            [_vm._v("-")]
                                          )
                                        : _vm._e(),
                                      !_vm.job.express
                                        ? _c("el-input", {
                                            staticStyle: { width: "150px" },
                                            attrs: {
                                              no: "20",
                                              value: _vm.job.mbl.substring(3),
                                              disabled: _vm.viewStatus
                                            }
                                          })
                                        : _vm._e(),
                                      _vm.job.express
                                        ? _c("el-input", {
                                            attrs: {
                                              no: "21",
                                              value: _vm.job.mbl,
                                              disabled: _vm.viewStatus
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _c(
                                "el-form-item",
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: { no: "22" },
                                      model: {
                                        value: _vm.job.predictionOperation,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "predictionOperation",
                                            $$v
                                          )
                                        },
                                        expression: "job.predictionOperation"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("SeaExport.PreAlertOperation")
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]),
                        _c("el-card", { staticClass: "form-card" }, [
                          _c(
                            "fieldset",
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.ContactPerson")
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "space-between"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: {
                                            flex: "1",
                                            "margin-right": "5px"
                                          },
                                          attrs: {
                                            no: "23",
                                            disabled: _vm.viewStatus
                                          },
                                          model: {
                                            value: _vm.job.customerContact,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.job,
                                                "customerContact",
                                                $$v
                                              )
                                            },
                                            expression: "job.customerContact"
                                          }
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t(
                                                "queryJob.DropDown"
                                              ),
                                              value: 0
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-link",
                                        {
                                          attrs: { no: "24" },
                                          on: {
                                            click: function($event) {
                                              _vm.showContactsInfoDialog = true
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("SeaExport.Detail"))
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: _vm.$t("SeaExport.Tel") } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      no: "25",
                                      disabled: _vm.viewStatus
                                    },
                                    model: {
                                      value: _vm.job.contactTelephone,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.job,
                                          "contactTelephone",
                                          $$v
                                        )
                                      },
                                      expression: "job.contactTelephone"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: _vm.$t("SeaExport.Fax") } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      no: "26",
                                      disabled: _vm.viewStatus
                                    },
                                    model: {
                                      value: _vm.job.contactFax,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "contactFax", $$v)
                                      },
                                      expression: "job.contactFax"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.LocalService")
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      no: "27",
                                      filterable: "",
                                      disabled: _vm.viewStatus,
                                      "select-type":
                                        _vm.selectTypeNames
                                          .local_cache_AirExportConstants$SUFFY_TYPES,
                                      "callback-method-type": "value",
                                      "default-value": _vm.job.loadingTerm,
                                      "tag-name": _vm.isZh
                                        ? "chineseName"
                                        : "englishName",
                                      "callback-params": { key: "loadingTerm" }
                                    },
                                    on: {
                                      parentCallBack: _vm.setJobSelectValue
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.BookingProperty")
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      no: "28",
                                      filterable: "",
                                      disabled: _vm.viewStatus,
                                      "select-type":
                                        _vm.selectTypeNames
                                          .local_cache_BookingTerm,
                                      "callback-method-type": "value",
                                      "default-value": _vm.job.bookingTerm,
                                      "callback-params": { key: "bookingTerm" }
                                    },
                                    on: {
                                      parentCallBack: _vm.setJobSelectValue
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SeaExport.CustomsDeclarationWay"
                                    )
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      no: "29",
                                      filterable: "",
                                      disabled: _vm.viewStatus,
                                      "select-type":
                                        _vm.selectTypeNames
                                          .local_cache_AirExportConstants$CUSTOM_CLAIMS,
                                      "callback-method-type": "value",
                                      "default-value":
                                        String(_vm.job.customClaim) || "",
                                      "tag-name": "chineseName",
                                      "callback-params": { key: "customClaim" }
                                    },
                                    on: {
                                      parentCallBack: _vm.setJobSelectValue
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm.job.customClaim === 1
                                ? _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "SeaExport.CustomsDeclarationType"
                                        )
                                      }
                                    },
                                    [
                                      _c("cargo-advance-select", {
                                        attrs: {
                                          no: "30",
                                          filterable: "",
                                          disabled: _vm.viewStatus,
                                          "select-type":
                                            _vm.selectTypeNames
                                              .local_cache_AirExportConstants$CUSTOM_CLAIMS2,
                                          "callback-method-type": "value",
                                          "default-value": _vm.job.customClaim2,
                                          "tag-name": "chineseName",
                                          "callback-params": {
                                            key: "customClaim2"
                                          }
                                        },
                                        on: {
                                          parentCallBack: _vm.setJobSelectValue
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.TradeMethod")
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      no: "31",
                                      filterable: "",
                                      disabled: _vm.viewStatus,
                                      "select-type":
                                        _vm.selectTypeNames
                                          .basic_data_TradeTerm,
                                      "callback-method-type": "value",
                                      "default-value": _vm.job.tradeTerm,
                                      "callback-params": { key: "tradeTerm" }
                                    },
                                    on: {
                                      parentCallBack: _vm.setJobSelectValue
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SeaExport.StatusOfCustomsDeclaration"
                                    )
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      no: "32",
                                      filterable: "",
                                      disabled: _vm.viewStatus,
                                      "select-type":
                                        _vm.selectTypeNames
                                          .local_cache_SystemConstants$DECLARE_CUSTOMS_STATE,
                                      "callback-method-type": "value",
                                      "default-value":
                                        String(_vm.job.declareCustomsState) ||
                                        "",
                                      "tag-name": _vm.isZh
                                        ? "chineseName"
                                        : "englishName",
                                      "callback-params": {
                                        key: "declareCustomsState"
                                      }
                                    },
                                    on: {
                                      parentCallBack: _vm.setJobSelectValue
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.TradeTerms")
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      no: "33",
                                      filterable: "",
                                      disabled: _vm.viewStatus,
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_IncoTerm,
                                      "callback-method-type": "value",
                                      "default-value": _vm.job.incoTerm,
                                      "callback-params": { key: "incoTerm" }
                                    },
                                    on: {
                                      parentCallBack: _vm.setJobSelectValue
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.AirlineCompany")
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      no: "34",
                                      disabled: _vm.viewStatus,
                                      filterable: "",
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_Company,
                                      "method-params": { airCmp: true },
                                      "callback-method-type": "value",
                                      "default-value": _vm.job.carrierId || "",
                                      "callback-params": { key: "carrierId" }
                                    },
                                    on: {
                                      parentCallBack: _vm.setJobSelectValue
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: _vm.$t("SeaExport.Flight") }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      no: "35",
                                      disabled: _vm.viewStatus
                                    },
                                    model: {
                                      value: _vm.job.voyageFlight,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "voyageFlight", $$v)
                                      },
                                      expression: "job.voyageFlight"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.OperationDate")
                                  }
                                },
                                [
                                  _c("el-date-picker", {
                                    attrs: {
                                      no: "36",
                                      disabled: _vm.viewStatus,
                                      type: "date",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.job.customsDate,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "customsDate", $$v)
                                      },
                                      expression: "job.customsDate"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.DateOfDeparture")
                                  }
                                },
                                [
                                  _c("el-date-picker", {
                                    attrs: {
                                      no: "37",
                                      disabled: _vm.viewStatus,
                                      type: "date",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.job.etd,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "etd", $$v)
                                      },
                                      expression: "job.etd"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.DateOfArrival")
                                  }
                                },
                                [
                                  _c("el-date-picker", {
                                    attrs: {
                                      no: "38",
                                      disabled: _vm.viewStatus,
                                      type: "date",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.job.eta,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "eta", $$v)
                                      },
                                      expression: "job.eta"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: { "margin-left": "0" },
                                      attrs: {
                                        no: "39",
                                        disabled: _vm.viewStatus,
                                        type: "primary"
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("SeaExport.Select")))]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        no: "40",
                                        disabled: _vm.viewStatus,
                                        type: "primary"
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("SeaExport.New")))]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        no: "41",
                                        disabled: _vm.viewStatus,
                                        type: "primary"
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("SeaExport.Add3")))]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        no: "42",
                                        disabled: _vm.viewStatus,
                                        type: "primary"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("SeaExport.Separate"))
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]),
                        _c("el-card", { staticClass: "form-card" }, [
                          _c(
                            "fieldset",
                            [
                              _c("el-form-item", { attrs: { label: "" } }, [
                                _c(
                                  "div",
                                  { staticStyle: { display: "flex" } },
                                  [
                                    _c(
                                      "el-checkbox",
                                      {
                                        attrs: {
                                          no: "43",
                                          disabled: _vm.viewStatus
                                        },
                                        model: {
                                          value: _vm.job.virtualHBL,
                                          callback: function($$v) {
                                            _vm.$set(_vm.job, "virtualHBL", $$v)
                                          },
                                          expression: "job.virtualHBL"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("SeaExport.FormalHbl"))
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-checkbox",
                                      {
                                        attrs: {
                                          no: "44",
                                          disabled: _vm.viewStatus
                                        },
                                        model: {
                                          value: _vm.job.itmService,
                                          callback: function($$v) {
                                            _vm.$set(_vm.job, "itmService", $$v)
                                          },
                                          expression: "job.itmService"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("SeaExport.ForeignTrade")
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("Payment.warehouseNo")
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      no: "45",
                                      disabled: _vm.viewStatus,
                                      type: "textarea",
                                      rows: 5
                                    },
                                    model: {
                                      value: _vm.job.warehouseNo,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "warehouseNo", $$v)
                                      },
                                      expression: "job.warehouseNo"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SeaExport.CustomerReferenceNumber"
                                    )
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      no: "46",
                                      disabled: _vm.viewStatus
                                    },
                                    model: {
                                      value: _vm.job.customerRefNo,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "customerRefNo", $$v)
                                      },
                                      expression: "job.customerRefNo"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.FirstLegNo")
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      no: "47",
                                      disabled: _vm.viewStatus
                                    },
                                    model: {
                                      value: _vm.job.relatedJob2,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "relatedJob2", $$v)
                                      },
                                      expression: "job.relatedJob2"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "KC No" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      no: "48",
                                      disabled: _vm.viewStatus
                                    },
                                    model: {
                                      value: _vm.job.kcNo,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "kcNo", $$v)
                                      },
                                      expression: "job.kcNo"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: _vm.$t("SeaExport.ItemNo") }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      no: "49",
                                      disabled: _vm.viewStatus
                                    },
                                    model: {
                                      value: _vm.job.poNo,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "poNo", $$v)
                                      },
                                      expression: "job.poNo"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SeaExport.MasterBLFreightTerm"
                                    )
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      no: "50",
                                      filterable: "",
                                      disabled: _vm.viewStatus,
                                      "select-type":
                                        _vm.selectTypeNames
                                          .basic_data_PaymentTerm,
                                      "callback-method-type": "value",
                                      "default-value": _vm.job.paymentTermMBL,
                                      "callback-params": {
                                        key: "paymentTermMBL"
                                      }
                                    },
                                    on: {
                                      parentCallBack: _vm.setJobSelectValue
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.HBLFreightClause")
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      no: "51",
                                      filterable: "",
                                      disabled: _vm.viewStatus,
                                      "select-type":
                                        _vm.selectTypeNames
                                          .basic_data_PaymentTerm,
                                      "callback-method-type": "value",
                                      "default-value": _vm.job.paymentTermHBL,
                                      "callback-params": {
                                        key: "paymentTermHBL"
                                      }
                                    },
                                    on: {
                                      parentCallBack: _vm.setJobSelectValue
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.SpaceRquirement")
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      no: "52",
                                      disabled: _vm.viewStatus
                                    },
                                    model: {
                                      value: _vm.job.cabinReq,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "cabinReq", $$v)
                                      },
                                      expression: "job.cabinReq"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SeaExport.OnBoardRequirements"
                                    )
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      no: "53",
                                      disabled: _vm.viewStatus
                                    },
                                    model: {
                                      value: _vm.job.loadReq,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "loadReq", $$v)
                                      },
                                      expression: "job.loadReq"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SeaExport.DocumentationRequirements"
                                    )
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      no: "54",
                                      disabled: _vm.viewStatus
                                    },
                                    model: {
                                      value: _vm.job.docReq,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "docReq", $$v)
                                      },
                                      expression: "job.docReq"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.CargoType")
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      no: "55",
                                      filterable: "",
                                      disabled: _vm.viewStatus,
                                      "select-type":
                                        _vm.selectTypeNames
                                          .basic_data_CargoType,
                                      "callback-method-type": "value",
                                      "default-value": _vm.job.cargoType,
                                      "callback-params": { key: "cargoType" }
                                    },
                                    on: {
                                      parentCallBack: _vm.setJobSelectValue
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.CargoSize")
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      no: "56",
                                      disabled: _vm.viewStatus,
                                      type: "textarea",
                                      rows: 3
                                    },
                                    model: {
                                      value: _vm.job.measurements,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "measurements", $$v)
                                      },
                                      expression: "job.measurements"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.SellingPrice")
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      no: "57",
                                      disabled: _vm.viewStatus
                                    },
                                    model: {
                                      value: _vm.job.selling,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "selling", $$v)
                                      },
                                      expression: "job.selling"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.BuyingPrice")
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      no: "58",
                                      disabled: _vm.viewStatus
                                    },
                                    model: {
                                      value: _vm.job.buying,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "buying", $$v)
                                      },
                                      expression: "job.buying"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.ProtocolType")
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      no: "59",
                                      filterable: "",
                                      disabled: _vm.viewStatus,
                                      "select-type":
                                        _vm.selectTypeNames
                                          .local_cache_SystemConstants$PROTOCOL_TYPES,
                                      "callback-method-type": "value",
                                      "default-value":
                                        String(_vm.job.protocolType) || "",
                                      "tag-name": "chineseName",
                                      "callback-params": { key: "protocolType" }
                                    },
                                    on: {
                                      parentCallBack: _vm.setJobSelectValue
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SeaExport.OperationRequirements"
                                    )
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      no: "60",
                                      disabled: _vm.viewStatus,
                                      type: "textarea",
                                      rows: 3
                                    },
                                    model: {
                                      value: _vm.job.operationContent,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.job,
                                          "operationContent",
                                          $$v
                                        )
                                      },
                                      expression: "job.operationContent"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]),
                        _c("el-card", { staticClass: "form-card" }, [
                          _c(
                            "fieldset",
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SeaExport.SalesBranchCompany"
                                    )
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      no: "61",
                                      disabled: _vm.viewStatus
                                    },
                                    model: {
                                      value: _vm.txtSalesOffice,
                                      callback: function($$v) {
                                        _vm.txtSalesOffice = $$v
                                      },
                                      expression: "txtSalesOffice"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: _vm.$t("SeaExport.Sales") } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "space-between"
                                      }
                                    },
                                    [
                                      _c("cargo-advance-select", {
                                        staticStyle: { width: "130px" },
                                        attrs: {
                                          no: "62",
                                          filterable: "",
                                          disabled: _vm.viewStatus,
                                          "select-type":
                                            _vm.selectTypeNames.basic_data_User,
                                          "callback-method-type": "value",
                                          "default-value": _vm.job.sales || "",
                                          "callback-params": { key: "sales" }
                                        },
                                        on: {
                                          parentCallBack: _vm.setJobSelectValue
                                        }
                                      }),
                                      _c(
                                        "el-checkbox",
                                        {
                                          attrs: {
                                            no: "63",
                                            disabled: _vm.viewStatus
                                          },
                                          model: {
                                            value: _vm.job.isProvisioned,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.job,
                                                "isProvisioned",
                                                $$v
                                              )
                                            },
                                            expression: "job.isProvisioned"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("SeaExport.Accrued"))
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.SalesOfGoods")
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      no: "64",
                                      filterable: "",
                                      disabled: _vm.viewStatus,
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_User,
                                      "callback-method-type": "value",
                                      "default-value":
                                        _vm.job.cargoSalesId == 0
                                          ? ""
                                          : _vm.job.cargoSalesId,
                                      "callback-params": { key: "cargoSalesId" }
                                    },
                                    on: {
                                      parentCallBack: _vm.setJobSelectValue
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.SalesDepartment")
                                  }
                                },
                                [
                                  _c("cargo-department-select", {
                                    attrs: {
                                      no: "65",
                                      disabled: _vm.viewStatus,
                                      "office-id": Number(_vm.job.salesOffice),
                                      "department-id": Number(
                                        _vm.job.salesDepartment
                                      )
                                    },
                                    on: {
                                      change: function(p) {
                                        _vm.job.salesDepartment = p.value
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.OperationCompany")
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      no: "66",
                                      disabled: _vm.viewStatus,
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_Office,
                                      filterable: "",
                                      "callback-params": { key: "opOffice" },
                                      "callback-method-type": "value",
                                      "default-value": _vm.job.opOffice
                                    },
                                    on: {
                                      parentCallBack: _vm.setJobSelectValue
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.Department")
                                  }
                                },
                                [
                                  _c("cargo-department-select", {
                                    attrs: {
                                      no: "67",
                                      disabled: _vm.viewStatus,
                                      "office-id": Number(_vm.job.opOffice),
                                      "department-id": Number(
                                        _vm.job.opDepartment
                                      )
                                    },
                                    on: {
                                      change: function(p) {
                                        _vm.job.opDepartment = p.value
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.Operation")
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      no: "68",
                                      filterable: "",
                                      disabled: _vm.viewStatus,
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_User,
                                      "callback-method-type": "value",
                                      "default-value":
                                        _vm.job.op == 0 ? "" : _vm.job.op,
                                      "callback-params": { key: "op" }
                                    },
                                    on: {
                                      parentCallBack: _vm.setJobSelectValue
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.CustomerService")
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      no: "69",
                                      filterable: "",
                                      disabled: _vm.viewStatus,
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_User,
                                      "callback-method-type": "value",
                                      "default-value":
                                        _vm.job.csr == 0 ? "" : _vm.job.csr,
                                      "callback-params": { key: "csr" }
                                    },
                                    on: {
                                      parentCallBack: _vm.setJobSelectValue
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.Documents")
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      no: "70",
                                      filterable: "",
                                      disabled: _vm.viewStatus,
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_User,
                                      "callback-method-type": "value",
                                      "default-value":
                                        _vm.job.dc == 0 ? "" : _vm.job.dc,
                                      "callback-params": { key: "dc" }
                                    },
                                    on: {
                                      parentCallBack: _vm.setJobSelectValue
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.AirlinePerson2")
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      no: "71",
                                      filterable: "",
                                      disabled: _vm.viewStatus,
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_User,
                                      "callback-method-type": "value",
                                      "default-value":
                                        _vm.job.planner == 0
                                          ? ""
                                          : _vm.job.planner,
                                      "callback-params": { key: "planner" }
                                    },
                                    on: {
                                      parentCallBack: _vm.setJobSelectValue
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.FieldOperation")
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      no: "72",
                                      filterable: "",
                                      disabled: _vm.viewStatus,
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_User,
                                      "callback-method-type": "value",
                                      "default-value":
                                        _vm.job.siteOP == 0
                                          ? ""
                                          : _vm.job.siteOP,
                                      "callback-params": { key: "siteOP" }
                                    },
                                    on: {
                                      parentCallBack: _vm.setJobSelectValue
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.OverseaOperation")
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      no: "73",
                                      filterable: "",
                                      disabled: _vm.viewStatus,
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_User,
                                      "callback-method-type": "value",
                                      "default-value":
                                        _vm.job.overseaOp == 0
                                          ? ""
                                          : _vm.job.overseaOp,
                                      "callback-params": { key: "overseaOp" }
                                    },
                                    on: {
                                      parentCallBack: _vm.setJobSelectValue
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.isAddUserDefinedRoles,
                                      expression: "isAddUserDefinedRoles"
                                    }
                                  ],
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_userDefinedRole1"
                                    )
                                  }
                                },
                                [
                                  _c("cargo-user-select", {
                                    ref: "userDefinedRoleId1",
                                    attrs: {
                                      no: "userDefinedRoleId1",
                                      "method-params": {
                                        officeId:
                                          _vm.$store.getters.currentOfficeId,
                                        category: "role",
                                        shape: "userDefinedRole1"
                                      },
                                      "default-value":
                                        _vm.job.userDefinedRoleId1 || "",
                                      "merge-load": true,
                                      disabled: _vm.viewStatus
                                    },
                                    on: {
                                      change: function(p) {
                                        _vm.pm.userDefinedRoleId1Handler(p)
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.isAddUserDefinedRoles,
                                      expression: "isAddUserDefinedRoles"
                                    }
                                  ],
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_userDefinedRole2"
                                    )
                                  }
                                },
                                [
                                  _c("cargo-user-select", {
                                    ref: "userDefinedRoleId2",
                                    attrs: {
                                      no: "userDefinedRoleId2",
                                      "method-params": {
                                        officeId:
                                          _vm.$store.getters.currentOfficeId,
                                        category: "role",
                                        shape: "userDefinedRole2"
                                      },
                                      "default-value":
                                        _vm.job.userDefinedRoleId2 || "",
                                      "merge-load": true,
                                      disabled: _vm.viewStatus
                                    },
                                    on: {
                                      change: function(p) {
                                        _vm.pm.userDefinedRoleId2Handler(p)
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                [
                                  _c("special-requests-grid", {
                                    attrs: {
                                      "customer-id": _vm.job.customerId,
                                      lob: _vm.job.lob,
                                      job: _vm.job,
                                      "is-edit": !_vm.viewStatus
                                    },
                                    model: {
                                      value: _vm.job.satisfiedRequests,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.job,
                                          "satisfiedRequests",
                                          $$v
                                        )
                                      },
                                      expression: "job.satisfiedRequests"
                                    }
                                  }),
                                  !_vm.viewStatus
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "justify-content": "flex-end"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "74",
                                                type: "primary"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("SeaExport.Add"))
                                              )
                                            ]
                                          ),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                no: "75",
                                                type: "primary"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("SeaExport.Delete")
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { "margin-top": "10px" },
                                  attrs: { label: _vm.$t("SeaExport.HsCode") }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      no: "76",
                                      disabled: _vm.viewStatus
                                    },
                                    model: {
                                      value: _vm.job.hsCode,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "hsCode", $$v)
                                      },
                                      expression: "job.hsCode"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.AdditionalNotes")
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      no: "76",
                                      disabled: _vm.viewStatus,
                                      type: "textarea",
                                      rows: 5
                                    },
                                    model: {
                                      value: _vm.job.remarks,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "remarks", $$v)
                                      },
                                      expression: "job.remarks"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]),
                        _c("el-card", { staticClass: "form-card" }, [
                          _c(
                            "fieldset",
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.UserDefinedField1")
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      no: "77",
                                      disabled: _vm.viewStatus,
                                      type: "textarea",
                                      rows: 5
                                    },
                                    model: {
                                      value: _vm.job.userDefinedField1,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.job,
                                          "userDefinedField1",
                                          $$v
                                        )
                                      },
                                      expression: "job.userDefinedField1"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.UserDefinedField2")
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      no: "78",
                                      disabled: _vm.viewStatus,
                                      type: "textarea",
                                      rows: 5
                                    },
                                    model: {
                                      value: _vm.job.userDefinedField2,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.job,
                                          "userDefinedField2",
                                          $$v
                                        )
                                      },
                                      expression: "job.userDefinedField2"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.UserDefinedField3")
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      no: "79",
                                      disabled: _vm.viewStatus,
                                      type: "textarea",
                                      rows: 5
                                    },
                                    model: {
                                      value: _vm.job.userDefinedField3,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.job,
                                          "userDefinedField3",
                                          $$v
                                        )
                                      },
                                      expression: "job.userDefinedField3"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    ),
                    _c(
                      "el-card",
                      { staticClass: "form-card second-row-card" },
                      [
                        _c(
                          "fieldset",
                          { staticStyle: { width: "fit-content" } },
                          [
                            _c(
                              "el-form-item",
                              { staticClass: "custom", attrs: { label: "" } },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "title-row",
                                    staticStyle: {
                                      display: "flex",
                                      "justify-content": "flex-start"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "font-size": "12px",
                                          "font-weight": "normal",
                                          color: "#404144",
                                          "margin-right": "330px"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("SeaExport.Quantity"))
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "font-size": "12px",
                                          "font-weight": "normal",
                                          color: "#404144"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("SeaExport.Weight")) +
                                            "KGS"
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "font-size": "12px",
                                          "font-weight": "normal",
                                          color: "#404144"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("SeaExport.Cubage")) +
                                            "CBM"
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "font-size": "12px",
                                          "font-weight": "normal",
                                          color: "#404144"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("SeaExport.ChargedWeight")
                                          ) + "M/T"
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            ),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "custom content-row",
                                attrs: {
                                  label: _vm.$t("SeaExport.Consignation")
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "justify-content": "flex-start"
                                    }
                                  },
                                  [
                                    _c("el-input-number", {
                                      attrs: {
                                        no: "80",
                                        value:
                                          _vm.job.quantityContract === 0
                                            ? undefined
                                            : _vm.job.quantityContract,
                                        disabled: _vm.viewStatus,
                                        "controls-position": "right"
                                      }
                                    }),
                                    _c("el-input-number", {
                                      attrs: {
                                        no: "81",
                                        value:
                                          _vm.job.weightContract === 0
                                            ? undefined
                                            : _vm.job.weightContract,
                                        disabled: _vm.viewStatus,
                                        "controls-position": "right",
                                        precision: 3
                                      }
                                    }),
                                    _c("el-input-number", {
                                      attrs: {
                                        no: "82",
                                        value:
                                          _vm.job.cubageContract === 0
                                            ? undefined
                                            : _vm.job.cubageContract,
                                        disabled: _vm.viewStatus,
                                        "controls-position": "right",
                                        precision: 3
                                      }
                                    }),
                                    _c("el-input-number", {
                                      attrs: {
                                        no: "83",
                                        value:
                                          _vm.job.chargeWeight === 0
                                            ? undefined
                                            : _vm.job.chargeWeight,
                                        disabled: _vm.viewStatus,
                                        "controls-position": "right",
                                        precision: 3
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            ),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "custom content-row",
                                attrs: { label: _vm.$t("SeaExport.Booking") }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "justify-content": "flex-start"
                                    }
                                  },
                                  [
                                    _c("el-input-number", {
                                      attrs: {
                                        no: "84",
                                        value:
                                          _vm.job.quantityBooking === 0
                                            ? undefined
                                            : _vm.job.quantityBooking,
                                        disabled: _vm.viewStatus,
                                        "controls-position": "right"
                                      }
                                    }),
                                    _c("el-input-number", {
                                      attrs: {
                                        no: "85",
                                        value:
                                          _vm.job.weightBooking === 0
                                            ? undefined
                                            : _vm.job.weightBooking,
                                        disabled: _vm.viewStatus,
                                        "controls-position": "right",
                                        precision: 3
                                      }
                                    }),
                                    _c("el-input-number", {
                                      attrs: {
                                        no: "86",
                                        value:
                                          _vm.job.cubageBooking === 0
                                            ? undefined
                                            : _vm.job.cubageBooking,
                                        disabled: _vm.viewStatus,
                                        "controls-position": "right",
                                        precision: 3
                                      }
                                    }),
                                    _c("el-input-number", {
                                      attrs: {
                                        no: "87",
                                        value:
                                          _vm.job.chargeWeightBooking === 0
                                            ? undefined
                                            : _vm.job.chargeWeightBooking,
                                        disabled: _vm.viewStatus,
                                        "controls-position": "right",
                                        precision: 3
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            ),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "custom content-row",
                                attrs: { label: _vm.$t("SeaExport.Actual") }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "justify-content": "flex-start"
                                    }
                                  },
                                  [
                                    _c("el-input-number", {
                                      attrs: {
                                        no: "88",
                                        value:
                                          _vm.job.quantityActual === 0
                                            ? undefined
                                            : _vm.job.quantityActual,
                                        disabled: _vm.viewStatus,
                                        "controls-position": "right"
                                      }
                                    }),
                                    _c("el-input-number", {
                                      attrs: {
                                        no: "89",
                                        value:
                                          _vm.job.weightActual === 0
                                            ? undefined
                                            : _vm.job.weightActual,
                                        disabled: _vm.viewStatus,
                                        "controls-position": "right",
                                        precision: 3
                                      }
                                    }),
                                    _c("el-input-number", {
                                      attrs: {
                                        no: "90",
                                        value:
                                          _vm.job.cubageActual === 0
                                            ? undefined
                                            : _vm.job.cubageActual,
                                        disabled: _vm.viewStatus,
                                        "controls-position": "right",
                                        precision: 3
                                      }
                                    }),
                                    _c("el-input-number", {
                                      attrs: {
                                        no: "91",
                                        value:
                                          _vm.job.cWeight === 0
                                            ? undefined
                                            : _vm.job.cWeight,
                                        disabled: _vm.viewStatus,
                                        "controls-position": "right",
                                        precision: 1
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm.job.operateType !== 0
                              ? _c(
                                  "el-form-item",
                                  {
                                    staticClass: "custom content-row",
                                    attrs: {
                                      label: _vm.$t("SeaExport.Documentation")
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "justify-content": "flex-start"
                                        }
                                      },
                                      [
                                        _c("el-input-number", {
                                          attrs: {
                                            no: "92",
                                            value:
                                              _vm.mawbDoc.quantity === 0
                                                ? undefined
                                                : _vm.mawbDoc.quantity,
                                            disabled: _vm.viewStatus,
                                            "controls-position": "right"
                                          }
                                        }),
                                        _c("el-input-number", {
                                          attrs: {
                                            no: "93",
                                            value:
                                              _vm.mawbDoc.weight === 0
                                                ? undefined
                                                : _vm.mawbDoc.weight,
                                            disabled: _vm.viewStatus,
                                            "controls-position": "right",
                                            precision: 3
                                          }
                                        }),
                                        _c("el-input-number", {
                                          attrs: {
                                            no: "94",
                                            value:
                                              _vm.mawbDoc.cubage === 0
                                                ? undefined
                                                : _vm.mawbDoc.cubage,
                                            disabled: _vm.viewStatus,
                                            "controls-position": "right",
                                            precision: 3
                                          }
                                        }),
                                        _c("el-input-number", {
                                          attrs: {
                                            no: "95",
                                            value:
                                              _vm.mawbDoc.cWeight === 0
                                                ? undefined
                                                : _vm.mawbDoc.cWeight,
                                            disabled: _vm.viewStatus,
                                            "controls-position": "right",
                                            precision: 1
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "justify-content": "flex-start"
                                }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("SeaExport.Package")
                                    }
                                  },
                                  [
                                    _c("cargo-packing-select", {
                                      attrs: {
                                        no: "96",
                                        "default-value": _vm.job.packing,
                                        "callback-params": {}
                                      },
                                      on: {
                                        change: function(p) {
                                          p.key = "packing"
                                          _vm.setJobSelectValue(p)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "custom",
                                    staticStyle: { "margin-left": "85px" },
                                    attrs: {
                                      label: _vm.$t("SeaExport.pbProportion"),
                                      "label-width": "80px"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          width: "210px"
                                        }
                                      },
                                      [
                                        _c("el-input-number", {
                                          staticStyle: { flex: "1" },
                                          attrs: {
                                            no: "97",
                                            disabled: _vm.viewStatus,
                                            "controls-position": "right"
                                          },
                                          model: {
                                            value: _vm.job.pbProportion,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.job,
                                                "pbProportion",
                                                $$v
                                              )
                                            },
                                            expression: "job.pbProportion"
                                          }
                                        }),
                                        _c("span", [_vm._v("%")])
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { "margin-left": "65px" },
                                    attrs: {
                                      label: _vm.$t("SeaExport.pbProportion2"),
                                      "label-width": "80px"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          width: "210px"
                                        }
                                      },
                                      [
                                        _c("el-input-number", {
                                          staticStyle: { flex: "1" },
                                          attrs: {
                                            no: "98",
                                            "controls-position": "right",
                                            disabled: _vm.viewStatus
                                          },
                                          model: {
                                            value: _vm.job.pbProportion2,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.job,
                                                "pbProportion2",
                                                $$v
                                              )
                                            },
                                            expression: "job.pbProportion2"
                                          }
                                        }),
                                        _c("span", [_vm._v("%")])
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _c("el-card", { staticClass: "form-card" }, [
                      _c("fieldset", { staticStyle: { width: "950px" } }, [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between"
                            }
                          },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-right": "55px" },
                                attrs: {
                                  label: _vm.$t(
                                    "SeaExport.EnglishDescriptionOfGoods"
                                  )
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticStyle: { position: "relative" } },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        no: "99",
                                        disabled: _vm.viewStatus,
                                        type: "textarea",
                                        rows: 8
                                      },
                                      model: {
                                        value: _vm.job.cargoEnglishName,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "cargoEnglishName",
                                            $$v
                                          )
                                        },
                                        expression: "job.cargoEnglishName"
                                      }
                                    }),
                                    _c("char-count", {
                                      attrs: { value: _vm.job.cargoEnglishName }
                                    })
                                  ],
                                  1
                                )
                              ]
                            ),
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-right": "55px" },
                                attrs: { label: _vm.$t("SeaExport.Marks") }
                              },
                              [
                                _c(
                                  "div",
                                  { staticStyle: { position: "relative" } },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        no: "100",
                                        disabled: _vm.viewStatus,
                                        type: "textarea",
                                        rows: 8
                                      },
                                      model: {
                                        value: _vm.job.mark,
                                        callback: function($$v) {
                                          _vm.$set(_vm.job, "mark", $$v)
                                        },
                                        expression: "job.mark"
                                      }
                                    }),
                                    _c("char-count", {
                                      attrs: { value: _vm.job.mark }
                                    })
                                  ],
                                  1
                                )
                              ]
                            ),
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-right": "45px" },
                                attrs: {
                                  label: _vm.$t(
                                    "SeaExport.ChineseDescriptionOfGoods"
                                  )
                                }
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    no: "101",
                                    disabled: _vm.viewStatus,
                                    type: "textarea",
                                    rows: 8
                                  },
                                  model: {
                                    value: _vm.job.cargoChineseName,
                                    callback: function($$v) {
                                      _vm.$set(_vm.job, "cargoChineseName", $$v)
                                    },
                                    expression: "job.cargoChineseName"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  ],
                  1
                )
              ])
            ]
          ),
          _c(
            "div",
            {
              staticClass: "form-card-wrapper custom-delivery-info",
              staticStyle: { width: "100%" }
            },
            [
              _c(
                "el-card",
                { staticClass: "form-card", staticStyle: { flex: "1" } },
                [
                  _c(
                    "el-form",
                    {
                      attrs: { "label-position": "left", "label-width": "90px" }
                    },
                    [
                      _c(
                        "fieldset",
                        { staticStyle: { "min-height": "300px" } },
                        [
                          _c("legend", [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.CustomerDeliveryInfo"))
                            )
                          ]),
                          _c(
                            "el-row",
                            { attrs: { gutter: 6 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "custom",
                                      attrs: {
                                        label: _vm.$t("SeaExport.Shipper")
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticStyle: { display: "flex" } },
                                        [
                                          _c("cargo-advance-select", {
                                            staticStyle: {
                                              flex: "1",
                                              "margin-right": "5px"
                                            },
                                            attrs: {
                                              no: "102",
                                              filterable: "",
                                              disabled: _vm.viewStatus,
                                              "select-type":
                                                _vm.selectTypeNames
                                                  .basic_data_Company,
                                              "method-params": {
                                                shipper: true
                                              },
                                              "callback-method-type": "value",
                                              "default-value":
                                                _vm.job.shipperId || "",
                                              "tag-name": "englishName",
                                              "callback-params": {
                                                key: "shipperId"
                                              }
                                            },
                                            on: {
                                              parentCallBack:
                                                _vm.setJobSelectValue
                                            }
                                          }),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                slot: "append",
                                                no: "103",
                                                type: "primary",
                                                disabled: _vm.viewStatus
                                              },
                                              slot: "append"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "SeaExport.CodeSearching"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _c("el-input", {
                                    attrs: {
                                      no: "104",
                                      disabled: _vm.viewStatus
                                    },
                                    model: {
                                      value: _vm.job.shipperLine1,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "shipperLine1", $$v)
                                      },
                                      expression: "job.shipperLine1"
                                    }
                                  }),
                                  _c("el-input", {
                                    attrs: {
                                      no: "105",
                                      disabled: _vm.viewStatus
                                    },
                                    model: {
                                      value: _vm.job.shipperLine2,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "shipperLine2", $$v)
                                      },
                                      expression: "job.shipperLine2"
                                    }
                                  }),
                                  _c("el-input", {
                                    attrs: {
                                      no: "106",
                                      disabled: _vm.viewStatus
                                    },
                                    model: {
                                      value: _vm.job.shipperLine3,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "shipperLine3", $$v)
                                      },
                                      expression: "job.shipperLine3"
                                    }
                                  }),
                                  _c("el-input", {
                                    attrs: {
                                      no: "107",
                                      disabled: _vm.viewStatus
                                    },
                                    model: {
                                      value: _vm.job.shipperLine4,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "shipperLine4", $$v)
                                      },
                                      expression: "job.shipperLine4"
                                    }
                                  }),
                                  _c("el-input", {
                                    attrs: {
                                      no: "108",
                                      disabled: _vm.viewStatus
                                    },
                                    model: {
                                      value: _vm.job.shipperLine5,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "shipperLine5", $$v)
                                      },
                                      expression: "job.shipperLine5"
                                    }
                                  }),
                                  _c("el-input", {
                                    attrs: {
                                      no: "109",
                                      disabled: _vm.viewStatus
                                    },
                                    model: {
                                      value: _vm.job.shipperLine6,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "shipperLine6", $$v)
                                      },
                                      expression: "job.shipperLine6"
                                    }
                                  }),
                                  _c("char-count", {
                                    staticStyle: { float: "right" },
                                    attrs: {
                                      inline: "",
                                      form: _vm.job,
                                      prefix: "shipper",
                                      "line-count": 6
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "custom",
                                      attrs: {
                                        label: _vm.$t("SeaExport.Consignee")
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticStyle: { display: "flex" } },
                                        [
                                          _c("cargo-advance-select", {
                                            staticStyle: {
                                              flex: "1",
                                              "margin-right": "5px"
                                            },
                                            attrs: {
                                              no: "110",
                                              filterable: "",
                                              disabled: _vm.viewStatus,
                                              "select-type":
                                                _vm.selectTypeNames
                                                  .basic_data_Company,
                                              "method-params": {
                                                consignee: true
                                              },
                                              "callback-method-type": "value",
                                              "default-value":
                                                _vm.job.consigneeId || "",
                                              "tag-name": "englishName",
                                              "callback-params": {
                                                key: "consigneeId"
                                              }
                                            },
                                            on: {
                                              parentCallBack:
                                                _vm.setJobSelectValue
                                            }
                                          }),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                slot: "append",
                                                no: "111",
                                                type: "primary",
                                                disabled: _vm.viewStatus
                                              },
                                              slot: "append"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "SeaExport.CodeSearching"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _c("el-input", {
                                    attrs: {
                                      no: "112",
                                      disabled: _vm.viewStatus
                                    },
                                    model: {
                                      value: _vm.job.consigneeLine1,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "consigneeLine1", $$v)
                                      },
                                      expression: "job.consigneeLine1"
                                    }
                                  }),
                                  _c("el-input", {
                                    attrs: {
                                      no: "113",
                                      disabled: _vm.viewStatus
                                    },
                                    model: {
                                      value: _vm.job.consigneeLine2,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "consigneeLine2", $$v)
                                      },
                                      expression: "job.consigneeLine2"
                                    }
                                  }),
                                  _c("el-input", {
                                    attrs: {
                                      no: "114",
                                      disabled: _vm.viewStatus
                                    },
                                    model: {
                                      value: _vm.job.consigneeLine3,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "consigneeLine3", $$v)
                                      },
                                      expression: "job.consigneeLine3"
                                    }
                                  }),
                                  _c("el-input", {
                                    attrs: {
                                      no: "115",
                                      disabled: _vm.viewStatus
                                    },
                                    model: {
                                      value: _vm.job.consigneeLine4,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "consigneeLine4", $$v)
                                      },
                                      expression: "job.consigneeLine4"
                                    }
                                  }),
                                  _c("el-input", {
                                    attrs: {
                                      no: "116",
                                      disabled: _vm.viewStatus
                                    },
                                    model: {
                                      value: _vm.job.consigneeLine5,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "consigneeLine5", $$v)
                                      },
                                      expression: "job.consigneeLine5"
                                    }
                                  }),
                                  _c("el-input", {
                                    attrs: {
                                      no: "117",
                                      disabled: _vm.viewStatus
                                    },
                                    model: {
                                      value: _vm.job.consigneeLine6,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "consigneeLine6", $$v)
                                      },
                                      expression: "job.consigneeLine6"
                                    }
                                  }),
                                  _c("char-count", {
                                    staticStyle: { float: "right" },
                                    attrs: {
                                      inline: "",
                                      form: _vm.job,
                                      prefix: "consignee",
                                      "line-count": 6
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "custom",
                                      attrs: {
                                        label: _vm.$t("SeaExport.NotifyParty")
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticStyle: { display: "flex" } },
                                        [
                                          _c("cargo-advance-select", {
                                            staticStyle: {
                                              flex: "1",
                                              "margin-right": "5px"
                                            },
                                            attrs: {
                                              no: "118",
                                              filterable: "",
                                              disabled: _vm.viewStatus,
                                              "select-type":
                                                _vm.selectTypeNames
                                                  .basic_data_Company,
                                              "method-params": { notify: true },
                                              "callback-method-type": "value",
                                              "default-value":
                                                _vm.job.notifyId || "",
                                              "tag-name": "englishName",
                                              "callback-params": {
                                                key: "notifyId"
                                              }
                                            },
                                            on: {
                                              parentCallBack:
                                                _vm.setJobSelectValue
                                            }
                                          }),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                slot: "append",
                                                type: "primary",
                                                disabled: _vm.viewStatus
                                              },
                                              slot: "append"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "SeaExport.CodeSearching"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _c("el-input", {
                                    attrs: {
                                      no: "119",
                                      disabled: _vm.viewStatus
                                    },
                                    model: {
                                      value: _vm.job.notifyLine1,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "notifyLine1", $$v)
                                      },
                                      expression: "job.notifyLine1"
                                    }
                                  }),
                                  _c("el-input", {
                                    attrs: {
                                      no: "120",
                                      disabled: _vm.viewStatus
                                    },
                                    model: {
                                      value: _vm.job.notifyLine2,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "notifyLine2", $$v)
                                      },
                                      expression: "job.notifyLine2"
                                    }
                                  }),
                                  _c("el-input", {
                                    attrs: {
                                      no: "121",
                                      disabled: _vm.viewStatus
                                    },
                                    model: {
                                      value: _vm.job.notifyLine3,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "notifyLine3", $$v)
                                      },
                                      expression: "job.notifyLine3"
                                    }
                                  }),
                                  _c("el-input", {
                                    attrs: {
                                      no: "122",
                                      disabled: _vm.viewStatus
                                    },
                                    model: {
                                      value: _vm.job.notifyLine4,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "notifyLine4", $$v)
                                      },
                                      expression: "job.notifyLine4"
                                    }
                                  }),
                                  _c("el-input", {
                                    attrs: {
                                      no: "123",
                                      disabled: _vm.viewStatus
                                    },
                                    model: {
                                      value: _vm.job.notifyLine5,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "notifyLine5", $$v)
                                      },
                                      expression: "job.notifyLine5"
                                    }
                                  }),
                                  _c("el-input", {
                                    attrs: {
                                      no: "124",
                                      disabled: _vm.viewStatus
                                    },
                                    model: {
                                      value: _vm.job.notifyLine6,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "notifyLine6", $$v)
                                      },
                                      expression: "job.notifyLine6"
                                    }
                                  }),
                                  _c("char-count", {
                                    staticStyle: { float: "right" },
                                    attrs: {
                                      inline: "",
                                      form: _vm.job,
                                      prefix: "notify",
                                      "line-count": 6
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        display: "inline-block",
                                        "line-height": "32px",
                                        "padding-bottom": "7px"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("SeaExport.SecondNotifyParty")
                                        )
                                      )
                                    ]
                                  ),
                                  _c("el-input", {
                                    attrs: {
                                      no: "125",
                                      disabled: _vm.viewStatus,
                                      type: "textarea",
                                      rows: 11
                                    },
                                    model: {
                                      value: _vm.job.alsoNotify,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "alsoNotify", $$v)
                                      },
                                      expression: "job.alsoNotify"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.showContactsInfoDialog
        ? _c("cargo-contacts-info-dialog", {
            attrs: {
              visible: _vm.showContactsInfoDialog,
              "customer-id": _vm.job.customerId,
              "customer-contact": _vm.job.customerContact
            },
            on: {
              "update:visible": function($event) {
                _vm.showContactsInfoDialog = $event
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }